<template>
    <div>
        <slot>
            <oc-accordion-item v-for="(item, index) in items" :key="index" :item="item">
                <template #header="{uniqueId}">
                    <slot name="header" :item="item" :uniqueId="uniqueId"></slot>
                </template>
                <template #content="{uniqueId}">
                    <slot name="content" :item="item" :uniqueId="uniqueId"></slot>
                </template>
            </oc-accordion-item>
        </slot>
    </div>
</template>
<script>
export default {
    name: 'oc-accordion',
    props: {
        startOpened: {
            type: Boolean,
            default: false
        },
        onlyOneActive: {
            type: Boolean,
            default: true
        },
        /**
         * [
         *     {
         *         id: 1, // optional
         *         header: 'Some title',
         *         content: 'some text content' // optional
         *         startOpened: true // optional
         *     }
         * ]
         */
        items: {
            type: Array,
            default: () => ([])
        },
        // expandIcon: {
        //     type: [Boolean, Function],
        //     default: false
        // },
        // expandIconPosition: {
        //     type: String,
        //     default: 'left',
        //     validator: function (value) {
        //         return ['left', 'right'].indexOf(value) !== -1
        //     }
        // }
    },
    data() {
        return {
            activeItems: {}
        }
    }
}
</script>
